import { ComplianceRequestsState } from 'src/app/compliance/store/state/compliance-requests.state';
import { Action, createReducer, on } from '@ngrx/store';
import * as complianceRequestsActions from 'src/app/compliance/store/actions/compliance-requests.actions';
import * as complianceLabRequestsActions from 'src/app/compliance/store/actions/compliance-lab.actions';

const initialState: ComplianceRequestsState = {
    complianceRequests: null,
    labTicketRequests: null,
    complianceTicketRequests: null,
    assignees: null,
    assigneesFilter: null,
    filter: null,
    filterLabTicketRequests: null,
    filterComplianceTicketRequests: null,
    error: null,
    errorLabTicketRequests: null,
    errorComplianceTicketRequests: null,
    statusUpdate: null,
    updatedRequestIds: null,
    reloadWithDelay: 0, // delay to allow update sterling status
    unmappedName: null,
    labRequestVendors: null,
    dsDocumentTypesIds: null,
    documentTypeConfiguration: null,
    dsMapped: [],
    candidateVendorTestCodes: []
};

const reducer = createReducer(
    initialState,
    on(
        complianceLabRequestsActions.updateDsHasDocumentTypeConfigurationOnSubmit,
        (state, action): ComplianceRequestsState => ({
            ...state,
            dsMapped: action.result
        })
    ),
    on(
        complianceLabRequestsActions.getDsHasDocumentTypeConfigurationSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            dsMapped: action.result
        })
    ),
    on(complianceLabRequestsActions.getDsHasDocumentTypeConfigurationFailure, (state, action) => ({
        ...state,
        dsMapped: [],
        error: JSON.stringify(action.error)
    })),
    on(
        complianceLabRequestsActions.getDsHasDocumentTypeConfiguration,
        (state): ComplianceRequestsState => ({
            ...state,
            dsMapped: []
        })
    ),
    on(
        complianceRequestsActions.setReloadGridDelay,
        (state, action): ComplianceRequestsState => ({
            ...state,
            reloadWithDelay: action.reloadWithDelay
        })
    ),
    on(
        complianceRequestsActions.getListOfComplianceRequestsSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            complianceRequests: action.complianceRequests,
            error: null
        })
    ),
    on(complianceRequestsActions.getListOfComplianceRequestsFailure, (state, action) => ({
        ...state,
        error: JSON.stringify(action.error)
    })),
    on(
        complianceRequestsActions.setComplianceRequestsFilter,
        (state, action): ComplianceRequestsState => ({
            ...state,
            filter: action.filter,
            complianceRequests: null
        })
    ),
    on(
        complianceRequestsActions.getListOfLabTicketRequestsSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            labTicketRequests: action.complianceRequests,
            errorLabTicketRequests: null
        })
    ),
    on(complianceRequestsActions.getListOfLabTicketRequestsFailure, (state, action) => ({
        ...state,
        errorLabTicketRequests: JSON.stringify(action.error),
        labTicketRequests: null
    })),
    on(
        complianceRequestsActions.setLabTicketRequestsFilter,
        (state, action): ComplianceRequestsState => ({
            ...state,
            filterLabTicketRequests: action.filter,
            labTicketRequests: null
        })
    ),
    on(
        complianceRequestsActions.getListOfComplianceTicketRequestsSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            complianceTicketRequests: action.complianceRequests,
            errorComplianceTicketRequests: null
        })
    ),
    on(complianceRequestsActions.getListOfComplianceTicketRequestsFailure, (state, action) => ({
        ...state,
        errorComplianceTicketRequests: JSON.stringify(action.error),
        complianceTicketRequests: null
    })),
    on(
        complianceRequestsActions.setComplianceTicketRequestsFilter,
        (state, action): ComplianceRequestsState => ({
            ...state,
            filterComplianceTicketRequests: action.filter,
            complianceTicketRequests: null
        })
    ),
    on(
        complianceRequestsActions.getComplianceRequestsAssigneesSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: null,
            assignees: action.assignees
        })
    ),
    on(
        complianceRequestsActions.getComplianceRequestsAssigneesFailure,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: action.error
        })
    ),
    on(
        complianceRequestsActions.getComplianceRequestsAssigneesFilterSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: null,
            assigneesFilter: action.assignees
        })
    ),
    on(
        complianceRequestsActions.getComplianceRequestsAssigneesFilterFailure,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: action.error
        })
    ),
    on(
        complianceRequestsActions.bulkStatusUpdate,
        (state, action): ComplianceRequestsState => ({
            ...state,
            statusUpdate: action.statusUpdate
        })
    ),
    on(
        complianceRequestsActions.bulkStatusUpdateSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            updatedRequestIds: action.updatedRequestIds
        })
    ),
    on(
        complianceRequestsActions.bulkStatusUpdateFailure,
        (state): ComplianceRequestsState => ({
            ...state,
            updatedRequestIds: []
        })
    ),
    on(
        complianceRequestsActions.setUnmappedName,
        (state, action): ComplianceRequestsState => ({
            ...state,
            unmappedName: action.data
        })
    ),
    on(
        complianceLabRequestsActions.getLabVendorsSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            labRequestVendors: action.result
        })
    ),
    on(
        complianceLabRequestsActions.getLabVendorsFailure,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: action.error
        })
    ),
    on(
        complianceLabRequestsActions.getDsDocumentTypeIdsSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            dsDocumentTypesIds: action.result
        })
    ),
    on(
        complianceLabRequestsActions.getDsDocumentTypeIdsFailure,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: action.error
        })
    ),
    on(
        complianceLabRequestsActions.getLabRequestDocumentTypeConfigurationSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            documentTypeConfiguration: action.result
        })
    ),
    on(
        complianceLabRequestsActions.getLabRequestDocumentTypeConfigurationFailure,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: action.error
        })
    ),
    on(
        complianceLabRequestsActions.getCandidateVendorTestCodesSuccess,
        (state, action): ComplianceRequestsState => ({
            ...state,
            candidateVendorTestCodes: action.testCodes
        })
    ),
    on(
        complianceLabRequestsActions.getCandidateVendorTestCodesFailure,
        (state, action): ComplianceRequestsState => ({
            ...state,
            error: action.error
        })
    )
);

export function complianceRequestsReducer(state: ComplianceRequestsState | undefined, action: Action) {
    return reducer(state, action);
}
